import { useParams } from "react-router-dom";
import { PageContainer } from "../../../App/Components/PageContainer/PageContainer";
import { Paper } from "@mui/material";
import Breadcrumb from "../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { ITabGroupConfig } from "../../../App/Typings/TabPanel";
import TabGroup from "../../../App/Components/TabGroup/TabGroup";
import { AppDetails } from "./Components/AppDetails/AppDetails";
import { Features } from "./Components/Features/Features";
import { Attributes } from "./Components/Attributes/Attributes";
import { useGetAbacAppQuery } from "../AbacAppQueries";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlags } from "../../../App/Typings/FeatureFlags";
import {
  selectCurrentTab,
  updateCurrentTab,
} from "../../../App/State/Slices/TabGroupSlice";
import { useDispatch, useSelector } from "react-redux";

export default function ManageAppPage() {
  const { id } = useParams<{ id: string }>();
  const { data: currentApp, isLoading } = useGetAbacAppQuery(id);
  var dispatch = useDispatch();

  var tabState = useSelector(selectCurrentTab);

  // Initialize EnableABACApplicationManagement LD flag
  // TODO: Remove with ABAC-32
  const { enableAbacApplicationManagement } = useFlags<FeatureFlags>();

  if (!enableAbacApplicationManagement) {
    return null;
  }

  if (isLoading) {
    return (
      <PageContainer>
        <p>Loading...</p>
      </PageContainer>
    );
  }

  if (!isLoading && currentApp) {
    const tabGroupConfig: ITabGroupConfig = {
      groupLabel: "ABAC Application Actions",
      id: "abac-app-tabs",
      currentTabState: tabState.currentTab ?? "App Details",
      changeTabState: (newTabState: any) => {
        dispatch(updateCurrentTab(newTabState));
      },
      tabs: [
        {
          label: "App Details",
          TabComponent: <AppDetails app={currentApp} />,
        },
        {
          label: "Features",
          TabComponent: <Features app={currentApp} />,
        },
        {
          label: "Attributes",
          TabComponent: <Attributes app={currentApp} />,
        },
      ],
    };

    return (
      enableAbacApplicationManagement && (
        <PageContainer>
          <Breadcrumb pageTitle={currentApp.name} />
          <h1 className="page-title">Manage {currentApp.name} </h1>
          <Paper sx={{ mt: 4, p: { xs: 2, lg: 4 } }}>
            <TabGroup config={tabGroupConfig} />
          </Paper>
        </PageContainer>
      )
    );
  }
}
